import "config";
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "traffic-property-app/serviceWorker";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("traffic-app"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
